<!--HEADER: steht schon waehrend des Ladens, damit die Seite nach der Zubuchung nicht leer ist.
    Nur bei einem Ladefehler entfaellt er - eine Erfolgsmeldung ueber einer Fehlermeldung waere
    widerspruechlich.-->
@if (errors.length === 0) {
  <div class="additional-booking-ordered__header row" id="additionalBookingOrderedHeader">
    <div class="additional-booking-ordered__header-col col-12">
      <h3 class="additional-booking-ordered__intro"
          *appApplyIfNotEmpty="translationService.getTranslation('additionalBooking_ordered_title')"
          [innerHTML]="translationService.getTranslation('additionalBooking_ordered_title')"></h3>
    </div>
    <div class="additional-booking-ordered__header-col col-12">
      <p class="additional-booking-ordered__description"
         *appApplyIfNotEmpty="translationService.getTranslation('additionalBooking_ordered_description')"
         [innerHTML]="translationService.getTranslation('additionalBooking_ordered_description')"></p>
    </div>
  </div>
}

@if (isLoading) {
  <div class="additional-booking-ordered__spinner" style="text-align: center;">
    <app-loading-spinner></app-loading-spinner>
  </div>
}

@if (!isLoading) {
  <app-general-errors [errors]="errors"></app-general-errors>

  @if (order) {
    <mat-card class="additional-booking-ordered mt-2">
      <div class="row additional-booking-ordered__data" id="additionalBookingOrderedData">
        @if (order.productDescription) {
          <div class="col-6" [innerHTML]="translationService.getTranslation('order_object')"></div>
          <div class="col-6">{{ order.productDescription }}</div>
        }
        @if (order.variantDescription) {
          <div class="col-6" [innerHTML]="translationService.getTranslation('order_edition')"></div>
          <div class="col-6">{{ order.variantDescription }}</div>
        }
        @if (order.subId) {
          <div class="col-6" [innerHTML]="translationService.getTranslation('order_id')"></div>
          <div class="col-6">{{ order.subId }}</div>
        }
        @if (order.validDate) {
          <div class="col-6" [innerHTML]="translationService.getTranslation('period')"></div>
          <div class="col-6">
            {{ order.validDate.validFrom | date }} -
            {{ order.validDate.validUntil
               ? (order.validDate.validUntil | date)
               : translationService.getTranslation('subscription_endless') }}
          </div>
        }
      </div>

      <div class="additional-booking-ordered__actions">
        <button mat-raised-button color="primary" (click)="continueBooking()"
                [innerHTML]="translationService.getTranslation('additionalBooking_button_continue')"></button>
        <button mat-raised-button class="additional-booking-ordered__subscriptions-btn"
                (click)="goToSubscriptions()"
                [innerHTML]="translationService.getTranslation('additionalBooking_button_toSubscriptions')"></button>
      </div>
    </mat-card>
  }
}
